import { call, put, takeEvery } from "redux-saga/effects";
//actions
import {
  GetUserDetailsSuccess,
  GetUserDetailsFailure,
} from "../../actions/Settings/GetUserDetails";
//constant
import { GET_USER_DETAILS } from "../../constants/Settings/GetUserDetails";
//request type
import getRequest from "../../../util/APIHelperGet";
import { baseUrl } from "../../../util/APIBaseUrl";

export const fetchUserDetailsRequest = async (actions) => {
  // eslint-disable-next-line no-return-await

  return await getRequest(`${baseUrl}/${actions.payload.request}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

function* fetchUserDetails(params) {
  try {
    let response = yield call(fetchUserDetailsRequest, params);
    yield put(GetUserDetailsSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(GetUserDetailsFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(GET_USER_DETAILS, fetchUserDetails);
}
